import { render, staticRenderFns } from "./ChartStream.vue?vue&type=template&id=0bef2a34&"
import script from "./ChartStream.vue?vue&type=script&lang=js&"
export * from "./ChartStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bef2a34')) {
      api.createRecord('0bef2a34', component.options)
    } else {
      api.reload('0bef2a34', component.options)
    }
    module.hot.accept("./ChartStream.vue?vue&type=template&id=0bef2a34&", function () {
      api.rerender('0bef2a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/ChartStream.vue"
export default component.exports